function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_iii_18_1325)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.305 19.4C28.675 19.4 28.165 18.89 28.165 18.26C28.165 17.63 28.675 17.12 29.305 17.12H29.525C29.785 17.12 30.005 16.91 30.005 16.64V15.37C30.005 15.11 29.795 14.89 29.525 14.89H29.345C28.715 14.89 28.175 14.4 28.165 13.77C28.155 13.13 28.665 12.61 29.305 12.61H29.525C29.785 12.61 30.005 12.4 30.005 12.13V10.57C30.005 10.33 29.825 10.13 29.585 10.1C28.155 9.91001 27.015 8.79 26.795 7.37C26.755 7.1 26.515 6.89001 26.235 6.89001H5.745C5.465 6.89001 5.225 7.09 5.185 7.37C4.965 8.78 3.835 9.89 2.415 10.09C2.175 10.12 1.995 10.32 1.995 10.56V12.13C1.995 12.39 2.20499 12.61 2.47499 12.61H2.65499C3.28499 12.61 3.825 13.1 3.835 13.73C3.845 14.37 3.335 14.89 2.695 14.89H2.47499C2.21499 14.89 1.995 15.1 1.995 15.37V16.64C1.995 16.9 2.20499 17.12 2.47499 17.12H2.695C3.325 17.12 3.835 17.63 3.835 18.26C3.835 18.89 3.325 19.4 2.695 19.4H2.47499C2.21499 19.4 1.995 19.61 1.995 19.88V21.46C1.995 21.7 2.175 21.9 2.415 21.93C3.835 22.12 4.965 23.23 5.185 24.64C5.225 24.91 5.465 25.11 5.745 25.11H26.255C26.535 25.11 26.775 24.91 26.815 24.64C27.035 23.23 28.165 22.12 29.575 21.93C29.815 21.9 29.995 21.7 29.995 21.46V19.88C29.995 19.62 29.785 19.4 29.515 19.4H29.305Z",
  fill: "url(#paint0_linear_18_1325)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.25989 11.98C6.25989 10.7235 7.27658 9.69495 8.54494 9.69495H23.4549C24.7233 9.69495 25.74 10.7235 25.74 11.98V20C25.74 21.2565 24.7233 22.285 23.4549 22.285H20.45C20.4175 22.2979 20.382 22.305 20.3449 22.305C20.3078 22.305 20.2724 22.2979 20.2399 22.285H11.76C11.7275 22.2979 11.692 22.305 11.6549 22.305C11.6178 22.305 11.5824 22.2979 11.5499 22.285H8.54494C7.28844 22.285 6.25989 21.2683 6.25989 20V11.98ZM20.63 21.7149H23.4549C24.4066 21.7149 25.1699 20.9435 25.1699 20V11.98C25.1699 11.0365 24.4066 10.265 23.4549 10.265H20.63V21.7149ZM20.0599 10.265V21.7149H11.94V10.265H20.0599ZM8.54494 10.265H11.3699V21.7149H8.54494C7.60144 21.7149 6.82999 20.9516 6.82999 20V11.98C6.82999 11.0365 7.59329 10.265 8.54494 10.265Z",
  fill: "url(#paint1_linear_18_1325)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.08503 12.17C8.57503 12.17 8.15503 12.59 8.15503 13.1V18.74C8.15503 19.25 8.57503 19.67 9.08503 19.67C9.59503 19.67 10.015 19.25 10.015 18.74V13.1C10.015 12.58 9.59503 12.17 9.08503 12.17Z",
  fill: "#C43B66"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.0249 12.17C22.5149 12.17 22.0949 12.59 22.0949 13.1V18.74C22.0949 19.25 22.5149 19.67 23.0249 19.67C23.5349 19.67 23.9549 19.25 23.9549 18.74V13.1C23.9549 12.58 23.5349 12.17 23.0249 12.17Z",
  fill: "#C53C66"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9951 18.29C17.061 18.29 17.9251 17.4259 17.9251 16.36C17.9251 15.2941 17.061 14.43 15.9951 14.43C14.9292 14.43 14.0651 15.2941 14.0651 16.36C14.0651 17.4259 14.9292 18.29 15.9951 18.29Z",
  fill: "#C43B66"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_iii_18_1325",
  x: 1.495,
  y: 6.39001,
  width: 29.01,
  height: 18.72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.55 0 0 0 0 0.769156 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_1325"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.909804 0 0 0 0 0.403922 0 0 0 0 0.427451 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_1325",
  result: "effect2_innerShadow_18_1325"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.811765 0 0 0 0 0.164706 0 0 0 0 0.439216 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow_18_1325",
  result: "effect3_innerShadow_18_1325"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18_1325",
  x1: 1.995,
  y1: 17.375,
  x2: 30.005,
  y2: 17.375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED3558"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF51A8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_18_1325",
  x1: 8.61993,
  y1: 15.3125,
  x2: 24.3074,
  y2: 15.3125,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C43B66"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C63C66"
})));

function SvgAdmissionTicketsColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmissionTicketsColor);
export default __webpack_public_path__ + "static/media/admission_tickets_color.402dca2c.svg";
export { ForwardRef as ReactComponent };